const $ = require("../utils/fetch");

export function createArea(name, parent, location, scopeLocation) {
  const params = {
    name: name,
    parent: parent,
    location: location,
    scopeLocation: scopeLocation,
  };
  location.loc.length == 0 ? delete params.location : "";
  scopeLocation.length == 0 ? delete params.scopeLocation : "";

  return $.put("/area", params);
}

export function getParentAreaList(areaId) {
  const params = {
    areaId: JSON.stringify(areaId),
  };
  return $.get("/area/ids", params);
}

export function getChildrenAreas(name, parent, level) {
  const params = {
    name: name,
    parent: JSON.stringify(parent),
    level: JSON.stringify(level),
  };
  name == "" ? delete params.name : "";
  parent.length == 0 ? delete params.parent : "";
  level.length == 0 ? delete params.level : "";

  return $.get("/area/list", params);
}

export function getAreaCount(name, parent, level) {
  const params = {
    name: name,
    parent: JSON.stringify(parent),
    level: JSON.stringify(level),
  };
  name == "" ? delete params.name : "";
  // parent.length==0 ? (delete params.parent) : '';
  level.length == 0 ? delete params.level : "";

  return $.get("/area/count", params);
}

export function updateArea(areaId, name, location, scopeLocation) {
  const params = {
    name: name,
    location: location,
    scopeLocation: scopeLocation,
  };
  location.loc.length == 0 ? (params.location = {}) : "";
  scopeLocation.length == 0 ? delete params.scopeLocation : "";

  return $.post("/area/" + areaId, params);
}

export function transferArea(areaId, targetArea, password) {
  const params = {
    targetArea: targetArea,
    // password: password
  };
  return $.post("/area/move/" + areaId, params);
}

export function deleteArea(areaId, targetArea, password) {
  const params = {
    targetArea: targetArea,
    password: password,
  };
  return $.toDelete("/area/" + areaId, params);
}

export function getAreaTrees(areaId) {
  const params = {
    areaId: JSON.stringify(areaId),
  };
  areaId.length == 0 ? delete params.areaId : "";

  return $.get("/area/child", params);
}



// WEBPACK FOOTER //
// ./src/api/area.js